import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { NoteColor, ProcessStep } from "../constants";

import {
    createSlide,
    redo,
    setTemplate,
    setSketchMode,
    setZoomLevel,
    showCreateNoteDialog,
    showHelp,
    undo,
    Action,
} from '../actions';
import {
    getHelpPanelState,
    getPaneState,
    getProcessStep,
    getSketchMode,
    getTemplateId,
    isRedoable,
    isUndoable,
    SketchMode,
    State
} from '../reducers';

import MainToolbar from '../components/MainToolbarView';
import * as React from "react";


interface StateProps {
    readonly isDrawerVisible: boolean,
    readonly isUndoable: boolean,
    readonly isRedoable: boolean,
    readonly processStep: ProcessStep,
    readonly templateId: number,
    readonly sketchMode: SketchMode,
    readonly zoomSliderValue: number,
}

interface DispatchProps {
    readonly onRedo: () => void,
    readonly onUndo: () => void,
    readonly onSelectTemplate: (templateId: number) => void,
    readonly onSelectSketchMode: (sketchMode: SketchMode) => void,
    readonly onShowCreateNoteDialog: (color: NoteColor) => void,
    readonly onCreateSlide: () => void,
    readonly onZoomOutClickedFactory: (zoomLevel: number) => () => void,
    readonly onZoomInClickedFactory: (zoomLevel: number) => () => void,
    readonly onZoomLevelChanged: (event: React.ChangeEvent<{}>, zoomLevel: number) => void,
    readonly onShowHelp: () => void,
}

interface Props extends StateProps {
    readonly onRedo: () => void,
    readonly onUndo: () => void,
    readonly onSelectTemplate: (templateId: number) => void,
    readonly onSelectSketchMode: (sketchMode: SketchMode) => void,
    readonly onShowCreateNoteDialog: (color: NoteColor) => void,
    readonly onCreateSlide: () => void,
    readonly onZoomOutClicked: () => void,
    readonly onZoomInClicked: () => void,
    readonly onZoomLevelChanged: (event: React.ChangeEvent<{}>, zoomLevel: number) => void,
    readonly onShowHelp: () => void,
}


const mapStateToProps = (state: State): StateProps => (
    {
        isDrawerVisible: getHelpPanelState(state).visible,
        isUndoable: isUndoable(state),
        isRedoable: isRedoable(state),
        processStep: getProcessStep(state),
        templateId: getTemplateId(state),
        sketchMode: getSketchMode(state),
        zoomSliderValue: getPaneState(state).zoomSliderValue,
    }
);

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onRedo: () => {
            dispatch(redo());
        },
        onUndo: () => {
            dispatch(undo());
        },
        onSelectTemplate: (templateId: number) => {
            dispatch(setTemplate(templateId));
        },
        onSelectSketchMode: (sketchMode: SketchMode) => {
            dispatch(setSketchMode(sketchMode));
        },
        onShowCreateNoteDialog: (color: NoteColor) => {
            dispatch(showCreateNoteDialog(color));
        },
        onCreateSlide: () => {
            dispatch(createSlide());
        },
        onZoomInClickedFactory: (zoomLevel: number) => () => {
            dispatch(setZoomLevel(Math.min(zoomLevel + 0.1, 1.0)));
        },
        onZoomOutClickedFactory: (zoomLevel: number) => () => {
            dispatch(setZoomLevel(Math.max(zoomLevel - 0.1, 0.0)));
        },
        onZoomLevelChanged: (event: React.ChangeEvent<{}>, zoomLevel: number) => {
            dispatch(setZoomLevel(zoomLevel));
        },
        onShowHelp: () => {
            dispatch(showHelp());
        }
    }
);

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): Props => (
    {
        ...stateProps,
        onRedo: dispatchProps.onRedo,
        onUndo: dispatchProps.onUndo,
        onSelectTemplate: dispatchProps.onSelectTemplate,
        onSelectSketchMode: dispatchProps.onSelectSketchMode,
        onShowCreateNoteDialog: dispatchProps.onShowCreateNoteDialog,
        onCreateSlide: dispatchProps.onCreateSlide,
        onZoomOutClicked: dispatchProps.onZoomOutClickedFactory(stateProps.zoomSliderValue),
        onZoomInClicked: dispatchProps.onZoomInClickedFactory(stateProps.zoomSliderValue),
        onZoomLevelChanged: dispatchProps.onZoomLevelChanged,
        onShowHelp: dispatchProps.onShowHelp,
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(MainToolbar);



// WEBPACK FOOTER //
// ./src/containers/MainToolbar.ts